import { useDroppable } from '@dnd-kit/core';

const DroppableRamp = ({ ramp, children, statusClass, onContextMenu }) => {
  const { isOver, setNodeRef } = useDroppable({
    id: `ramp-${ramp.LOCATIONID}`,
    data: { ramp },
    disabled: ramp.STATUS === 3 || ramp.STATUS === 2,
  });

  return (
    <div
      ref={setNodeRef}
      className={`ramp-slot ${statusClass} ${isOver ? 'ramp-hover' : ''}`}
      onContextMenu={onContextMenu}
    >
      {children}
    </div>
  );
};

export default DroppableRamp;